export default __webpack_public_path__ + "static/media/Days_15.3e32657d.png";